import React from "react";
import styles from "./spinner.module.scss";
import {ReactComponent as Spinner} from "../../../../assets/editors/spinner.svg";
import {Box, CircularProgress} from "@mui/material";

export const PageSpinner = () => {
    return (
        <div className={styles.loader}>
            <Box className={styles.loaderSpinnerBox}>
                <CircularProgress/>
                {/*<Spinner style={{maxWidth: `inherit`, maxHeight: `inherit`, padding: "4px"}}/>*/}
            </Box>
        </div>
    )
}
